import { render, staticRenderFns } from "./YaziPage.vue?vue&type=template&id=d7222af2&scoped=true&"
import script from "./YaziPage.vue?vue&type=script&lang=js&"
export * from "./YaziPage.vue?vue&type=script&lang=js&"
import style0 from "./YaziPage.vue?vue&type=style&index=0&id=d7222af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7222af2",
  null
  
)

export default component.exports